interface FeedbackCardProps {
  index: number;
  name: string;
  dateOfIncident: string;
  position: string;
  department: string;
  supervisor: string;
  dateOfHire?: string;
  policyViolation: string;
  immediateFeedback: string;
  emailOfFeedback: string;
  descriptionOfFeedback: string;
  expectationForImprovement: string;
  createdAt?: string;
}

const FeedbackCard = ({
  index,
  name,
  dateOfIncident,
  position,
  department,
  supervisor,
  dateOfHire,
  policyViolation,
  immediateFeedback,
  emailOfFeedback,
  descriptionOfFeedback,
  expectationForImprovement,
  createdAt,
}: FeedbackCardProps) => {
  return (
    <div className="mb-4 p-3 border rounded" style={{ backgroundColor: '#f8f9fa' }}>
      <h6 className="text-primary mb-3">
        <i className="fas fa-user mr-2" />
        {index + 1}. {name}
      </h6>

      <div className="row">
        <div className="col-md-6">
          <p>
            <strong>Date of Incident:</strong> {dateOfIncident}
          </p>
          <p>
            <strong>Position:</strong> {position}
          </p>
          <p>
            <strong>Department:</strong> {department}
          </p>
          <p>
            <strong>Supervisor:</strong> {supervisor}
          </p>
          {dateOfHire && (
            <p>
              <strong>Date of Hire:</strong> {dateOfHire}
            </p>
          )}
        </div>
        <div className="col-md-6">
          <p>
            <strong>Policy Violation:</strong> {policyViolation}
          </p>
          <p>
            <strong>Immediate Feedback:</strong> {immediateFeedback}
          </p>
          <p>
            <strong>Email Copy:</strong> {emailOfFeedback}
          </p>
          {createdAt && (
            <p>
              <strong>Created At:</strong> {createdAt}
            </p>
          )}
        </div>
      </div>

      <div className="mt-3">
        <p>
          <strong>Description of Feedback:</strong>
        </p>
        <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
          {descriptionOfFeedback}
        </p>
      </div>

      <div className="mt-3">
        <p>
          <strong>Expectation for Improvement:</strong>
        </p>
        <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
          {expectationForImprovement}
        </p>
      </div>
    </div>
  );
};

export default FeedbackCard;
